import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './PosizionePersonalizzazioneOrdineStatus.module.sass'
import Alert from '../Alert/Alert'
import { AlertTriangle, Checkmark } from '@components/icons'
import useTrans from '@hooks/useTrans'


interface Props {
  status?: '' | 'completed' | 'unsaved'
  variant?: 'icon' | 'full'
  className?: string
}

const PosizionePersonalizzazioneOrdineStatus = (props: Props) => {

  const { 
    status = '',
    variant = 'full',
    className = '',
  } = props

  const t = useTrans()

  return ['completed', 'unsaved'].includes(status) ? (
    <div className={cn(styles.root, styles[`root--${status}`], className)}>
    <Alert 
      variant={status === 'completed' ? 'success' : 'warning'} 
      styleVariant='basic' 
      icon={status === 'completed' ? <Checkmark /> : <AlertTriangle />} 
      placeholder={variant !== 'icon' ? t(status === 'completed' ? 'Completato' : 'Modifiche non salvate') : null} 
      className={styles.triggerStatus} 
    />
    </div>
  ) : <></>
}

export default PosizionePersonalizzazioneOrdineStatus
